import React from 'react';
import PropTypes from 'prop-types';
import MasterDataManagementTRSTable from './MasterDataManagementTRSTable';

const MasterDataManagementTRSComponent = ({
  trsData,
  handleGridChanges,
  gridColumnState,
  handleGridColumnStateChange,
  refreshGridTRSData,
  handleEditButtonClick,
  handleDeleteButtonClick,
  handleDismissErrorMessage,
}) => {
  return (
    <div>
      <div>
        <MasterDataManagementTRSTable
          trsData={trsData}
          handleGridChanges={handleGridChanges}
          gridColumnState={gridColumnState}
          handleGridColumnStateChange={handleGridColumnStateChange}
          refreshGridTRSData={refreshGridTRSData}
          handleEditButtonClick={handleEditButtonClick}
          handleDeleteButtonClick={handleDeleteButtonClick}
          handleDismissErrorMessage={handleDismissErrorMessage}
        />
      </div>
    </div>
  );
};

MasterDataManagementTRSComponent.propTypes = {
  trsData: PropTypes.arrayOf(
    PropTypes.shape({
      trsID: PropTypes.number,
      reitName: PropTypes.string,
      reitStatus: PropTypes.string,
      initialQuarter: PropTypes.string,
      finalQuarter: PropTypes.string,
      trsName: PropTypes.string,
    })
  ),
  selectedTRS: PropTypes.object,
  refreshGridTRSData: PropTypes.object,
  handleEditButtonClick: PropTypes.func,
  handleDeleteButtonClick: PropTypes.func,
  handleConfirmButtonClick: PropTypes.func,
  handleDismissErrorMessage: PropTypes.func,
  handleGridColumnStateChange: PropTypes.func,
  handleGridChanges: PropTypes.func.isRequired,
  gridColumnState: PropTypes.object,
  gridCurrentState: PropTypes.object,
  handleSubmit: PropTypes.func,
  showDeleteTRSConfirmationModal: PropTypes.bool,
  toggleShowDeleteTRSConfirmationModal: PropTypes.func,
  toggleShowEditTRSRowDataModal: PropTypes.func,
};

export default MasterDataManagementTRSComponent;
